export enum ActivityMenuItem {
    EDIT,
    DELETE,
    SEE_REPORT,
    //DETAIL,
    RESCHEDULE,
    RESEND_INFORM,
    CANCEL,
    START,
    FINISH,
    FORCEDFINISH,
}